/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MonthPlanChangeVariableCostIncomePercentRequestDto
 */
export interface MonthPlanChangeVariableCostIncomePercentRequestDto {
  /**
   *
   * @type {string}
   * @memberof MonthPlanChangeVariableCostIncomePercentRequestDto
   */
  fundId: string;
  /**
   *
   * @type {string}
   * @memberof MonthPlanChangeVariableCostIncomePercentRequestDto
   */
  incomeTypeId: string;
  /**
   *
   * @type {number}
   * @memberof MonthPlanChangeVariableCostIncomePercentRequestDto
   */
  percent: number;
}

export function MonthPlanChangeVariableCostIncomePercentRequestDtoFromJSON(
  json: any
): MonthPlanChangeVariableCostIncomePercentRequestDto {
  return MonthPlanChangeVariableCostIncomePercentRequestDtoFromJSONTyped(json, false);
}

export function MonthPlanChangeVariableCostIncomePercentRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MonthPlanChangeVariableCostIncomePercentRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    fundId: json["fundId"],
    incomeTypeId: json["incomeTypeId"],
    percent: json["percent"],
  };
}

export function MonthPlanChangeVariableCostIncomePercentRequestDtoToJSON(
  value?: MonthPlanChangeVariableCostIncomePercentRequestDto | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    fundId: value.fundId,
    incomeTypeId: value.incomeTypeId,
    percent: value.percent,
  };
}
